<template>
  <div class="content h-auto">

    <!-- Loading state -->
    <div class="mt-5" v-if="loading">
      <loading-state/>
      <h4 class="mb-4 text-center">Loading your booking details</h4>
    </div>

    <!-- Booking Lookup Form -->
    <div class="card" v-else>
      <div class="card-body">
        <h4 class="mb-4">{{ heading }}</h4>

        <div class="alert alert-danger" v-if="error.messages.length > 0">
          <ul class="mb-0">
            <li class="mb-0" v-for="(error, index) in error.messages" :key="index">
              {{ error }}
            </li>
          </ul>
        </div>

        <div class="form-group">
          <label>Enter your email address</label>
          <input tabindex="1" type="email" class="form-control" v-model="form.email"
                 placeholder="email@address.com" :disabled="loading"
                 :class="{'is-invalid': error.email}" v-on:keyup.enter="validateAndSubmit()">
          <div class="invalid-feedback" v-if="error.email">Your email address is missing</div>
        </div>

        <div class="form-group">
          <label>
            Enter your order reference
            &ndash;
            <a href="#" class="text-link text-sm" v-b-modal.order-id-help-modal>Where do I find this?</a>
          </label>
          <input tabindex="2" type="text" class="form-control" inputmode="numeric" pattern="[0-9]*"
                 v-model="form.orderRef" :disabled="loading"
                 placeholder="e.g. 123456" :class="{'is-invalid': error.orderRef}"
                 v-on:keyup.enter="validateAndSubmit()">
          <div class="invalid-feedback" v-if="error.orderRef">Your order reference is missing</div>
        </div>
        <button tabindex="3"
                class="btn continue-btn btn-block btn-lg"
                @click="validateAndSubmit()"
                :disabled="loading">
          {{ btnText }}
        </button>
      </div>
    </div>

    <b-modal id="order-id-help-modal" title="Where do I find my order ID?" ok-only>
      <p>When you placed an order with us, you will have received a booking confirmation email, which contains your
        order ID.</p>
    </b-modal>
  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  props: {
    heading: {
      type: String,
      default: 'Lookup your booking'
    },
    btnTitle: {
      type: String,
      default: 'Find order'
    }
  },

  data() {
    return {
      loading: false,
      form: {email: '', orderRef: ''},
      error: {email: false, orderRef: false, messages: []}
    }
  },

  computed: {
    btnText() {
      return this.loading ? 'Please Wait' : this.btnTitle;
    }
  },

  created() {
    if (this.$route.query) {
      const {email, order_ref} = this.$route.query;
      if (email && order_ref) {
        this.form.email = email;
        this.form.orderRef = order_ref;
        this.validateAndSubmit();
      }
    }
  },

  methods: {
    ...mapActions([
      "retrieveOrder",
      "retrieveOrderDevices",
      "resetOrderState"
    ]),

    validateAndSubmit() {
      // @todo validate email... *roll eyes*
      this.error.messages = [];
      this.error.email = this.form.email.length === 0;
      this.error.orderRef = this.form.orderRef.length === 0;

      if (!this.error.email && !this.error.orderRef) {
        this.loading = true;
        this.resetOrderState();

        this.retrieveOrder(this.form)
            .then(() => this.retrieveOrderDevices(this.form))
            .then(() => {
              this.$emit('lookupComplete');
            })
            .catch((error) => {
              this.loading = false;
              this.error.messages = error.response.data.messages;
              this.$emit('lookupError');
            });
      }
    },
  }
}
</script>